<template>
    <v-container fluid>
        <v-row no-gutters class="mb-2">
            <v-spacer />
            <v-btn color="primary" small :disabled="disabled" @click="apriNuovo">
                <v-icon left small>add</v-icon> Aggiungi {{ value.length ? etichetta(prossimoNumero) : 'audit' }}
            </v-btn>
        </v-row>

        <v-data-table :headers="headers" :items="righe" hide-default-footer :items-per-page="-1" dense
            no-data-text="Nessun audit programmato">
            <template v-slot:item.deroga="{ item }">
                <v-chip x-small :color="item.deroga ? 'warning' : 'grey lighten-2'">
                    {{ item.deroga ? 'SI' : 'NO' }}
                </v-chip>
            </template>
            <template v-slot:item.azioni="{ item }">
                <v-icon class="mr-2" :disabled="disabled" @click="apriModifica(item)">edit</v-icon>
                <v-icon v-if="isUltimo(item)" :disabled="disabled" @click="eliminaRiga(item)">delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogEdit" max-width="500px" persistent>
            <v-card>
                <v-card-title class="text-h6">{{ etichetta(editedItem.numero) }}</v-card-title>
                <v-card-text>
                    <v-select v-if="editedItem.sceltaPartenza" v-model="editedItem.numero" :items="opzioniPartenza"
                        label="Tipo di audit" hint="L'audit iniziale e' facoltativo: si puo' partire da una sorveglianza"
                        persistent-hint dense class="mb-3" />
                    <v-select v-model="editedItem.auditor" :items="auditors" item-text="username" item-value="username"
                        label="Auditor" clearable dense />
                    <campo-data v-model="editedItem.programmazione" label="Data programmata" />
                    <v-switch v-model="editedItem.deroga" label="Deroga" dense />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogEdit = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salvaRiga">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { get_listaAuditorConAdmin } from "@/api/api.auditor.js";
import { modifica_programmazione_audit } from "@/api/api.clienti.js";
import CampoData from "@/components/cliente/CampoData.vue";

export default {
    name: "ProgrammazioneAudit",

    components: { CampoData },

    props: {
        value: { type: Array, default: () => [] },
        companyCode: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
    },

    data: () => ({
        auditors: [],
        opzioniPartenza: [{ text: "Audit iniziale", value: 0 }, ...Array.from({ length: 10 }, (_, i) => ({ text: `Audit ${i + 1}a sorveglianza`, value: i + 1 }))],
        dialogEdit: false,
        editedItem: {},

        headers: [
            { text: "Tipo audit", value: "etichetta", sortable: false },
            { text: "Auditor", value: "auditor", sortable: false },
            { text: "Data programmata", value: "dataFormattata", sortable: false },
            { text: "Deroga", value: "deroga", sortable: false },
            { text: "Azioni", value: "azioni", sortable: false },
        ],
    }),

    methods: {
        etichetta(numero) {
            return numero === 0 ? "Audit iniziale" : `Audit ${numero}a sorveglianza`;
        },

        formattaData(data) {
            if (!data) return "";
            try {
                return this.$i2kFunctions.formatISODate(data.substring(0, 10));
            } catch {
                return data;
            }
        },

        isUltimo(item) {
            return item.numero === this.numeroMassimo;
        },

        apriNuovo() {
            this.editedItem = {
                numero: this.prossimoNumero,
                // Primo audit del cliente: l'utente sceglie da dove partire (iniziale o una sorveglianza).
                sceltaPartenza: this.value.length === 0,
                companyCode: this.companyCode,
                auditor: null,
                programmazione: null,
                data: null,
                deroga: false,
                nonConformita: false,
                note: "",
            };
            this.dialogEdit = true;
        },

        apriModifica(item) {
            this.editedItem = { ...item };
            this.dialogEdit = true;
        },

        salvaRiga() {
            const { sceltaPartenza, ...riga } = this.editedItem;
            const altre = this.value.filter((r) => r.numero !== riga.numero);
            this.$emit("input", [...altre, riga].sort((a, b) => a.numero - b.numero));
            this.dialogEdit = false;
        },

        async eliminaRiga(item) {
            let confirm = await this.$confirm.open(
                "Elimina audit",
                "Eliminare <b>" + this.etichetta(item.numero) + "</b>?"
            );
            if (!confirm) return;

            const res = await modifica_programmazione_audit({ CodiceAzienda: this.companyCode, Programmazione: [item] }, "elimina");
            if (res.data === "OK") {
                this.$emit("input", this.value.filter((r) => r.numero !== item.numero));
            } else {
                this.$toast.alert(res.data);
            }
        },

        async caricaAuditors() {
            const res = await get_listaAuditorConAdmin();
            this.auditors = res.data;
        },
    },

    computed: {
        numeroMassimo() {
            return this.value.length ? Math.max(...this.value.map((r) => r.numero)) : -1;
        },

        prossimoNumero() {
            return this.numeroMassimo + 1;
        },

        righe() {
            return this.value
                .map((r) => ({ ...r, etichetta: this.etichetta(r.numero), dataFormattata: this.formattaData(r.programmazione) }))
                .sort((a, b) => a.numero - b.numero);
        },
    },

    mounted() {
        this.caricaAuditors();
    },
};
</script>
